module.exports = __webpack_public_path__ + "img/favicon.6fca079.png";